module.exports = __webpack_public_path__ + "static/media/circle-icon.3bf3f103.png";